<template>
    <div>
        <DataLoader :is_on="creating_report" />
        <div id="table" class="report-table predmeti-report">
            <div class="rocisnik-top">
                <div class="rokovnik-title">Izvještaj troškovnika</div>
                <div class="filters-list">
                    <div>
                        <b>Period:</b> 01.10.2022. - 31.10.2022.
                    </div>
                    <div>
                        <b>Odvjetnik:</b> Bruno Pilošta
                    </div>
                    <div>
                        <b>Za:</b> Nadležno tijelo
                    </div>
                </div>
                <!-- <div class="remove-this" v-if="nositelj != null" @click="filterNositelj()">
                    <div v-if="!filter_active" class="archived-destroyed-element unisti"><b>Filtriraj predmete gdje je odabrani odvjetnik nositelj</b></div>
                    <div v-else class="archived-destroyed-element sve"><b>Prikaži sve predmete odabranog odvjetnika</b></div>
                </div> -->
            </div>
            <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
            <div id="wrapp-roc-pdf">
                <div class="report-row report-main-header">
                    <div class="column column3 bolded">
                        Naziv
                    </div>
                    <div class="column column2">
                        Predmet
                    </div>
                    <div class="column column1">
                        Odvjetnik
                    </div>
                    <div class="column column4">
                        Datum izrade
                    </div>
                    <div class="column column5">
                        Ukupna vrijednost (EUR)
                    </div>
                    <!-- <div class="column column6">
                        Članovi tima
                    </div> -->
                </div>
                <div class="report-section">
                    <!-- <div class="report-row report-date-row"></div> -->
                    <div v-for="(tros,key) in all_troskovnici" :key="key" class="report-row report-rociste">
                        <div class="column column3 bolded">
                            {{tros.name}}
                        </div>
                        <div class="column column2">
                            <div>{{tros.predmet.ime_predmeta}}</div>
                        </div>
                        <div class="column column1">
                            <div>{{getOdvjetnik(tros)}}</div>
                        </div>
                        <div class="column column4">
                            <div>
                                {{getDate(tros.time_created)}}
                            </div>
                        </div>
                        <div class="column column5">
                            <div>
                                {{getFormatedCurrency(tros.recreate_pdf_structure.total)}}
                            </div>
                        </div>
                    </div>
                    <div class="report-row report-main-header">
                        <div class="column column3 bolded">
                        </div>
                        <div class="column column2">
                            <div></div>
                        </div>
                        <div class="column column1">
                            <div></div>
                        </div>
                        <div style="justify-content: flex-end;" class="column column4">
                            <div>
                                Sveukupno: 
                            </div>
                        </div>
                        <div class="column column5">
                            <div>
                                124,550.00
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from "moment";
import $ from 'jquery';
import gsap from 'gsap';
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader';

export default {
    components:{
        DataLoader,
    },
    data() {
        return {
            all_troskovnici: [],
            creating_report: false,
        }
    },
    methods: {
        getFormatedCurrency(total){
            return total.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.");
        },
        getOdvjetnik(tros){
            let od = tros.predmet.predmet_odvjetnik_connector.find(od=>od.status_id == 2).odvjetnik;
            return `${od.ime} ${od.prezime}`;
        },
        async print() {
            this.creating_report = true;
            let temp_str = $("html").clone()
            $(temp_str).find(".print-wrapper,.entry-exit,.remove-this").remove()
            let html_to_print = $(temp_str)[0].outerHTML
            await ms_calendar.printCalendar(html_to_print).then(async(resp) => {
                var newBlob = new Blob([resp.data], {
                  type: "application/pdf",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download =`${this.$t("reports.naplata.file_name")}${moment().format("l")}.pdf`;
                link.click();
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                }, 100);
                this.creating_report = false;
            }).catch((_err)=>{
                this.creating_report = false;
            })
            //html_to_print sadrzi html izvjestaj spreman za print
            //poslati html_to_print na back endpoint
        },
        getDate(date) {
            return moment(date).format("DD.MM.yyyy.");
        },
        getToday() {
            return moment().format("DD.MM.yyyy.");
        },
        getDayName(date) {
            return moment(date).format("dddd");
        },
        getSatiEvent(fullDateTime) {
            return moment(fullDateTime).format("LT");
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    created(){
        this.all_troskovnici = this.$store.state.naplata_report_data.all_troskovnici;
    },
    mounted() {
        document.body.classList.add("new-entry");
        if(this.$store.state.naplata_report_data.all_troskovnici.length == 0){
            this.$router.go(-1);
        }

        $(".entry-exit").hover(
            function () {
                gsap.to($(this).find("img"), 0.3, {
                    rotation: 180,
                    transformOrigin: "center",
                });
            },
            function () {
                gsap.to($(this).find("img"), 0.5, {
                    rotation: -180,
                    transformOrigin: "center",
                });
            }
        );
    },
    destroyed() {
        this.$store.state.predmeti_report_data={
			all_predmeti: [],
			naslov: '',
			odvjetnik_nositelj:null,
			odvjetnik_name:''
		}
        document.body.classList.remove("new-entry");
        $(".entry-exit").off();
    },
}
</script>